var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient } from '@angular/common/http';
import { CrazyCallConfigService } from './crazycall-config.service';
import { AppConfigService } from './app-config.service';
import { mapResponse } from '../domain/configurationMapper';
import { flatMap } from 'rxjs/operators';
var LeadGenerationConfigurationService = /** @class */ (function () {
    function LeadGenerationConfigurationService(http, crazyCallConfigService, appConfigService) {
        this.http = http;
        this.crazyCallConfigService = crazyCallConfigService;
        this.appConfigService = appConfigService;
    }
    LeadGenerationConfigurationService.prototype.leadGenerationExists = function () {
        var appId = this.crazyCallConfigService.appId;
        return this.http
            .get(this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL + "configuration/exists", {
            params: { appId: appId },
        })
            .map(function (_a) {
            var exists = _a.exists;
            return exists;
        });
    };
    LeadGenerationConfigurationService.prototype.createProject = function (config) {
        var _this = this;
        return this.leadGenerationExists().pipe(flatMap(function (exists) { return (exists ? _this.createNewProject(config) : _this.saveInitialConfiguration(config)); }));
    };
    LeadGenerationConfigurationService.prototype.addOrigin = function (origin) {
        return this.http.post('/lead-generation/settings/add-origin', { origin: origin });
    };
    LeadGenerationConfigurationService.prototype.updateConfiguration = function (config) {
        return this.http
            .put(this.baseUrl + "/projects/" + config.projectId, this.mapConfigTimeToSeconds(config), {})
            .map(function (data) { return mapResponse(data, config.projectId); });
    };
    LeadGenerationConfigurationService.prototype.saveInitialConfiguration = function (config) {
        return this.postWithConfiguration('configuration', config);
    };
    LeadGenerationConfigurationService.prototype.saveDefaultConfiguration = function (config) {
        return this.http.post(this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL + "configuration/default", this.mapConfigTimeToSeconds(config), { observe: 'response' });
    };
    LeadGenerationConfigurationService.prototype.checkInstallation = function (url) {
        return this.http.get(this.baseUrl + "/check-code", {
            params: { url: url },
        });
    };
    LeadGenerationConfigurationService.prototype.createNewProject = function (config) {
        return this.postWithConfiguration(this.crazyCallConfigService.appId + "/projects", config);
    };
    Object.defineProperty(LeadGenerationConfigurationService.prototype, "baseUrl", {
        get: function () {
            return this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL + this.crazyCallConfigService.appId;
        },
        enumerable: true,
        configurable: true
    });
    LeadGenerationConfigurationService.prototype.postWithConfiguration = function (url, config, mapConfig) {
        if (mapConfig === void 0) { mapConfig = this.mapConfigTimeToSeconds; }
        return this.http.post("" + this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL + url, mapConfig(config));
    };
    // noinspection JSMethodCanBeStatic
    LeadGenerationConfigurationService.prototype.mapConfigTimeToSeconds = function (c) {
        return __assign({}, c, { timeBetweenShownPopups: c.timeBetweenShownPopups * 60, timeBetweenSubmittedPopups: c.timeBetweenSubmittedPopups * 60 });
    };
    return LeadGenerationConfigurationService;
}());
export { LeadGenerationConfigurationService };
